import { render } from "./GenericList.vue?vue&type=template&id=1e2d1c8f"
import script from "./GenericList.vue?vue&type=script&lang=js"
export * from "./GenericList.vue?vue&type=script&lang=js"

import "./GenericList.vue?vue&type=style&index=0&id=1e2d1c8f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__